import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { I18N_STORAGE_KEY, I18N_URL_PARAM_KEY, LanguageCodeEnum, type SupportedLanguage } from '@/constants/i18n'
import enCommon from '@/i18n/en/common.json'
import enComponents from '@/i18n/en/components.json'
import enPages from '@/i18n/en/pages.json'
// 直接导入翻译资源，构建工具会自动处理 CDN 缓存（通过文件 hash）
import zhCommon from '@/i18n/zh/common.json'
import zhComponents from '@/i18n/zh/components.json'
import zhPages from '@/i18n/zh/pages.json'
import { normalizeLanguage } from '@/utils/i18n'

// 从 URL 参数获取语言
const getLanguageFromUrl = (): SupportedLanguage | null => {
  if (typeof window === 'undefined') {
    return null
  }
  const params = new URLSearchParams(window.location.search)
  const lang = params.get(I18N_URL_PARAM_KEY)
  return lang ? normalizeLanguage(lang) : null
}

// 从 URL 参数获取初始语言（优先级最高）
const initialLanguage = getLanguageFromUrl()

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // 默认语言（如果 URL 参数有值则使用 URL 参数，否则让检测器从 localStorage 读取）
    lng: initialLanguage || undefined,
    // 回退语言配置
    fallbackLng: {
      // 默认回退到英文
      default: [LanguageCodeEnum.Zh],
      // zh 相关语言回退到 zh
      zh: [LanguageCodeEnum.Zh],
      // en 相关语言回退到 en
      en: [LanguageCodeEnum.En],
    },
    // 支持的语言列表
    supportedLngs: [LanguageCodeEnum.Zh, LanguageCodeEnum.En],
    // 直接导入资源（构建工具会自动添加 hash，实现 CDN 缓存适配）
    resources: {
      [LanguageCodeEnum.Zh]: { common: zhCommon, pages: zhPages, components: zhComponents },
      [LanguageCodeEnum.En]: { common: enCommon, pages: enPages, components: enComponents },
    },
    // 语言检测配置
    detection: {
      // 检测顺序：localStorage -> navigator -> htmlTag
      // URL 参数已在初始化时处理（最高优先级）
      order: ['localStorage', 'navigator', 'htmlTag'],
      // localStorage 中存储的 key
      lookupLocalStorage: I18N_STORAGE_KEY,
      // 缓存用户语言选择
      caches: ['localStorage'],
      // 转换检测到的语言代码
      convertDetectedLanguage: (lng: string) => {
        return normalizeLanguage(lng)
      },
    },
    // 调试模式（开发环境）
    debug: import.meta.env.DEV,
    // 插值配置
    interpolation: {
      escapeValue: false, // React 已经转义
    },
    // 命名空间加载策略
    load: 'currentOnly', // 只加载当前语言
    // 清理代码
    cleanCode: false, // 保留完整的语言代码（如 zh）
  })

export { useTranslation } from 'react-i18next'
export { i18n }
